import React from 'react';
import { motion } from 'framer-motion';
const LoadingChart: React.FC = () => {
  return <div className="w-full h-full flex items-center justify-center" data-id="element-11707">
      <motion.div className="flex space-x-2" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.3
    }} data-id="element-11708">
        {[0, 1, 2].map(index => <motion.div key={index} className="w-3 h-12 bg-blue-600 rounded-full" animate={{
        scaleY: [1, 1.5, 1],
        opacity: [0.5, 1, 0.5]
      }} transition={{
        duration: 1,
        repeat: Infinity,
        delay: index * 0.2
      }} data-id="element-11709" />)}
      </motion.div>
    </div>;
};
export default LoadingChart;